/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Recreate_Confirm_TitleInputs */

const vi_order_recreate_confirm_title = /** @type {(inputs: Order_Recreate_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huỷ đơn và tạo lại?`)
};

/**

* @param {Order_Recreate_Confirm_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_recreate_confirm_title = /** @type {((inputs?: Order_Recreate_Confirm_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Recreate_Confirm_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_recreate_confirm_title(inputs)
});